import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
import { pxToVw } from '@/modules/styled/cssUnits';
import styled from 'styled-components';

export const StyledPublicActivityType = styled.div`
  .header {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: ${pxToVw(80)};

    .first-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: ${pxToVw(20)};

      .title {
        display: flex;
        align-items: center;
        gap: ${pxToVw(18)};
        margin-bottom: ${pxToVw(20)};

        h1 {
          margin-top: ${pxToVw(5)};
        }
      }
    }
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.md}) {
    .header {
      .first-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 20px;
        margin-bottom: 20px;
      }
      .title {
        gap: 10px;
        margin-top: ${pxToVw(64)};
        margin-bottom: 20px;
      }
    }
  }
`;
